/**
 * Tiklama tabanli collector'lar: click (autocapture), outbound_click,
 * file_download, rage_click ve dead_click.
 */
import { AUTO_EVENTS } from "../events";
import trackerConfig from "../config";
import { describeElement, isExternalLink } from "./dom";

const CLICK_THROTTLE_MS = 300;
const RAGE_WINDOW_MS = 1000;
const RAGE_CLICK_COUNT = 3;
const RAGE_RADIUS_PX = 30;
const DEAD_CLICK_WAIT_MS = 1000;
const DOWNLOAD_EXT_REGEX = /\.(pdf|docx?|xlsx?|pptx?|csv|zip|rar|7z|tar|gz|dmg|exe|apk|mp3|mp4|txt|json|xml)(\?|#|$)/i;

class ClicksCollector {
    constructor(tracker) {
        this.tracker = tracker;
        this.lastClickAt = 0;
        this.rageClicks = [];
    }

    start() {
        const self = this;
        document.addEventListener(
            "click",
            function (event) {
                try {
                    self.onClick(event);
                } catch (e) {
                    /* musteri sayfasinin akisi bozulmamali */
                }
            },
            true
        );
    }

    onClick(event) {
        const target = event.target;
        if (!target || target.nodeType !== 1) return;

        const anchor = target.closest ? target.closest("a[href]") : null;
        const href = anchor ? anchor.getAttribute("href") : "";

        if (trackerConfig.isEnabled("rageClick")) this.trackRage(event);
        if (trackerConfig.isEnabled("fileDownload") && href && DOWNLOAD_EXT_REGEX.test(href)) {
            const info = describeElement(target, event);
            this.tracker.emit(
                AUTO_EVENTS.FILE_DOWNLOAD,
                {
                    href: info.href,
                    file_name: this.fileName(href),
                },
                { click: info }
            );
        }
        if (trackerConfig.isEnabled("outboundClick") && href && isExternalLink(href)) {
            const info = describeElement(target, event);
            this.tracker.emit(
                AUTO_EVENTS.OUTBOUND_CLICK,
                {
                    href: info.href,
                    host: this.linkHost(href),
                    text: info.text,
                },
                { click: info }
            );
            // Sayfa hemen degisebilir; event'i beklemeden gonderiyoruz.
            this.tracker.flush("outbound_click");
        }

        if (trackerConfig.isEnabled("click")) {
            const now = Date.now();
            if (now - this.lastClickAt >= CLICK_THROTTLE_MS) {
                this.lastClickAt = now;
                const info = describeElement(target, event);
                this.tracker.emit(
                    AUTO_EVENTS.CLICK,
                    {
                        selector: info.selector,
                        text: info.text,
                    },
                    { click: info }
                );
            }
        }

        if (trackerConfig.isEnabled("deadClick")) this.trackDead(event, target);
    }

    fileName(href) {
        try {
            const url = new URL(href, window.location.href);
            const parts = url.pathname.split("/");
            return parts[parts.length - 1].slice(0, 120);
        } catch (e) {
            return "";
        }
    }

    linkHost(href) {
        try {
            return new URL(href, window.location.href).hostname;
        } catch (e) {
            return "";
        }
    }

    /** Ayni bolgeye kisa surede tekrarlanan tiklamalar kullanici sikintisinin gostergesi. */
    trackRage(event) {
        const now = Date.now();
        const x = event.clientX || 0;
        const y = event.clientY || 0;
        this.rageClicks = this.rageClicks.filter(function (item) {
            return now - item.ts <= RAGE_WINDOW_MS;
        });
        this.rageClicks.push({ ts: now, x: x, y: y });
        if (this.rageClicks.length < RAGE_CLICK_COUNT) return;

        const near = this.rageClicks.filter(function (item) {
            return Math.abs(item.x - x) <= RAGE_RADIUS_PX && Math.abs(item.y - y) <= RAGE_RADIUS_PX;
        });
        if (near.length < RAGE_CLICK_COUNT) return;

        this.rageClicks = [];
        const info = describeElement(event.target, event);
        this.tracker.emit(
            AUTO_EVENTS.RAGE_CLICK,
            {
                selector: info.selector,
                click_count: near.length,
            },
            { click: info }
        );
    }

    /** Tiklamadan sonra URL ve DOM degismediyse tiklama sonucsuz sayilir. */
    trackDead(event, target) {
        const self = this;
        const url = window.location.href;
        const bodyLength = document.body ? document.body.innerHTML.length : 0;
        const info = describeElement(target, event);
        if (info.href) return; // link tiklamalari zaten navigasyon uretir

        setTimeout(function () {
            const urlChanged = window.location.href !== url;
            const domChanged = document.body ? Math.abs(document.body.innerHTML.length - bodyLength) > 32 : false;
            if (urlChanged || domChanged) return;
            self.tracker.emit(
                AUTO_EVENTS.DEAD_CLICK,
                {
                    selector: info.selector,
                    text: info.text,
                },
                { click: info }
            );
        }, DEAD_CLICK_WAIT_MS);
    }
}

export default ClicksCollector;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/collectors/clicks.js
// module id = null
// module chunks = 